<template>
    <div>
        <b-card title="" border-variant="primary">
            <form-base-document-invigilando
                :documents-state-data="documents_maintenance_invigilando"
                :documents-columns="columns"
                :documents-route="documents_by_route_maintenance_invigilando"
                :context="'document-invigilando'"
                :create-permission="can('create_gei_children_maintenance_invigilando')"
                :delete-permission="can('delete_gei_children_maintenance_invigilando')"
            />
        </b-card>
    </div>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import {mapState} from "vuex"
import formBaseDocumentInvigilando
    from "@/views/gei/children_installations/form/tabMaintenance/components/base/formBaseInvigilando"

import {mapFields} from "vuex-map-fields"

export default {
    name: "FormContractProviderDocuments",
    components: {
        BCard,
        formBaseDocumentInvigilando
    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'effective_date', label: 'Fecha Realización', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState('childrenInstallation', []),
        ...mapState('childrenInstallationDocuments', []),
        ...mapFields({
            documents_maintenance_invigilando: 'childrenInstallationDocuments.documents_maintenance_invigilando',
            documents_by_route_maintenance_invigilando: 'childrenInstallationDocuments.documents_by_route_maintenance_invigilando',
            child_installation: 'childrenInstallation.child_installation',
        }),
    },
    mounted() {
       this.context = 'document-invigilando'
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
    }

}
</script>